export const MESSAGES = {
    '1': 'Password reset succeeded; please login'
}
